export const agentUsageData = {
    billingCycle: "Jun 1 – Jun 30, 2026",
    status: "No Overage",
  
    agent: {
      name: "John Doe",
      email: "john.doe@example.com",
      mobile: "+91 9876543210",
      industry: "Real Estate",
      createdAt: "10/06/2026",
    },
  
    plan: {
      name: "Standard",
      includedMinutes: 1000,
      overageRate: 8,
      monthlyCap: 50000,
    },
  
    usage: {
      usedMinutes: 742,
      remainingMinutes: 258,
      extraMinutes: 0,
      usagePercentage: 74.2,
    },
  
    billing: {
      estimatedBill: 25000,
      estimatedOverage: 0,
      monthlyCap: 50000,
      remainingCap: 25000,
      overageRate: 8,
    },
  };